import { authGet } from '../../../utils/authFetch';
import { wmServerAddress } from '../../../common/MetaSetting';
import { fetchHttpResponseHandler, fetchHttpExceptionHandler } from '../../../util/UtilFunction';

export function fetchMemoViewByMemoId(memoId: string) {
  return authGet(`${wmServerAddress}/view/memo/${memoId}`)
    .then((response: any) => fetchHttpResponseHandler(response))
    .catch(fetchHttpExceptionHandler);
}
